export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9852.647f3e9b.jpg";